import React, {Fragment} from 'react';

import ModalDatePicker from 'presentation/components/ModalDatePicker';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {format, parseISO} from 'date-fns';
import {DateFilterProps} from './types';
import {StyledButton} from './styles';
import {useDateFilter} from './hooks/useDateFilter';

const {applyFilters} = translations['pt-br'].commons;

export function DateFilter(props: DateFilterProps) {
	const {openDatePickerState, setOpenDatePickerState, formatted, handleClearDates} =
		useDateFilter(props.firstDate, props.secondDate, props.handleFilter);
	return (
		<Fragment>
			<StyledButton
				variant="text"
				size="small"
				onClick={() => setOpenDatePickerState(true)}
				endIcon={<Icon name="edit" size={20} />}
				data-tag-id={props.dataTagId?.openButton}
				>
				{formatted}
			</StyledButton>
			<ModalDatePicker
				dataTagId={props.dataTagId}
				externalOpen={openDatePickerState}
				onAbandonModal={() => setOpenDatePickerState(false)}
				currentFirstDate={props.firstDate ? parseISO(props.firstDate) : new Date()}
				currentSecondDate={props.secondDate ? parseISO(props.secondDate) : new Date()}
				selectFirstDate={() => null}
				selectSecondDate={() => null}
				selectDates={date => {
					const {firstDate, secondDate} = date;
					if (!firstDate || !secondDate) return;

					props.handleFilter({
						dtInicio: format(firstDate, 'yyyy-MM-dd'),
						dtFim: format(secondDate, 'yyyy-MM-dd'),
					});

					setOpenDatePickerState(false);
				}}
				showClearButton={true}
				onClearDates={handleClearDates}
				hideOpenButton={true}
				isSecondDateOptional
				adjustDateInterval={true}
				customLabelConfirmButton={applyFilters}
				showNextMonthDay={false}
				showPrevMonthDay={false}
				shouldHaveDateIntervals={true}
				includeDateIntervals={{
					start: (() => {
						const base = props.secondDate ? parseISO(props.secondDate) : new Date();
						base.setMonth(base.getMonth() - 3);
						return base;
					})(),
					end: props.secondDate ? parseISO(props.secondDate) : new Date(),
				}}
			/>
		</Fragment>
	);
}
